import { Component } from '@angular/core';
import { LocalUtils } from 'app/restricted/restricted.utils';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent {
  colors = LocalUtils.colorsDefault;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar/app-sidebar.component.ts